import { render } from "./End.vue?vue&type=template&id=1039802e"
import script from "./End.vue?vue&type=script&lang=js"
export * from "./End.vue?vue&type=script&lang=js"
script.render = render

export default script